import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

function NotificationMenuDropdown({
  children = null,
  button = null,
  className = 'tv-filter-list__element',
  buttonClass = 'tv-notification_header',
  visible = false,
  setVisible = () => {},
}) {
  const dropdownRef = useRef(null);
  
  const toggleMenu = () => {
    if (toggleTimeout.current) {
      window.clearTimeout(toggleTimeout.current);
    }
    toggleTimeout.current = window.setTimeout(() => {
      setVisible(prevVisible => !prevVisible);
    }, 200);
  };

  const handleClickOutside = event => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setVisible(false);
    }
  };

  useEffect(() => {
    if (visible) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [visible]);

  const onBlur = event => {
    const { currentTarget } = event;
    window.setTimeout(() => {
      if (!currentTarget.contains(document.activeElement)) {
        // toggleMenu();
        setVisible(false);
      }
    }, 250);
  };

  const toggleTimeout = useRef(null);

  return (
    <span ref={dropdownRef} onBlur={onBlur} className={className}>
      <div
        // role="button"
        tabIndex="-1"
        onClick={toggleMenu}
        onKeyDown={() => {}}
        className={buttonClass}
        // aria-label="Notification button"
      >
        {button}
      </div>
      {visible && children}
    </span>
  );
}

NotificationMenuDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  button: PropTypes.node.isRequired,
  className: PropTypes.string.isRequired,
  buttonClass: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired,
  setVisible: PropTypes.func.isRequired,
};

export default NotificationMenuDropdown;
